import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { LogoutComponent } from './components/logout/logout.component';

@NgModule({
    declarations: [LogoutComponent],
    exports: [LogoutComponent],
    imports: [RouterModule, SharedModule],
})
export class AuthModule {}
